export default {
    PAGE: {
        UMSTRUKTURIERUNGSANTRAG: {
            TEIL_1: '/umstrukturierungsantrag/teil-1',
            TEIL_1_NEW: '/umstrukturierungsantrag/teil-1/new/:antragsjahr',
            TEIL_1_EDIT: '/umstrukturierungsantrag/teil-1/:antrag_id/edit',
            TEIL_1_DETAILS: '/umstrukturierungsantrag/teil-1/:antrag_id',
            TEIL_1_CHECK: '/umstrukturierungsantrag/teil-1/:antrag_id/check',
            TEIL_1_POSITION_NEW: '/umstrukturierungsantrag/teil-1/:antrag_id/new-position',
            TEIL_1_POSITION_EDIT: '/umstrukturierungsantrag/teil-1/:antrag_id/position/:position_id/edit',
            TEIL_2: '/umstrukturierungsantrag/teil-2',
            TEIL_2_NEW: '/umstrukturierungsantrag/:antragName/new/:antragsjahr',
            TEIL_2_EDIT: '/umstrukturierungsantrag/:antragName/:antrag_id/edit',
            TEIL_2_DETAILS: '/umstrukturierungsantrag/:antragName/:antrag_id',
            TEIL_2_POSITION_NEW: '/umstrukturierungsantrag/:antragName/:antrag_id/new-position',
            TEIL_2_POSITION_EDIT: '/umstrukturierungsantrag/:antragName/:antrag_id/position/:position_id/edit',
            TEIL_2_POSITION_QUELLFLAECHE_NEW: '/umstrukturierungsantrag/:antragName/:antrag_id/position/:position_id/new-quellflaeche',
            TEIL_2_POSITION_QUELLFLAECHE_EDIT: '/umstrukturierungsantrag/:antragName/:antrag_id/position/:position_id/quellflaeche/:quellflaeche_id?',
            WIZARD: '/umstrukturierungsantrag/:antragName/:antrag_id/online-abgabe',
            TEIL_2_CHECK: '/umstrukturierungsantrag/:antragName/:antrag_id/check',
        },
    },
    API: {
        UMSTRUKTURIERUNGSANTRAG: {
            TEIL_1: '/betrieb/:betrieb_nr/umstrukturierungsantrag/teil-1',
            TEIL_1_CHECK: '/betrieb/:betrieb_nr/umstrukturierungsantrag/teil-1/check',
            TEIL_1_DETAILS: '/betrieb/:betrieb_nr/umstrukturierungsantrag/teil-1/:antrag_id',
            TEIL_1_POSITION: '/betrieb/:betrieb_nr/umstrukturierungsantrag/teil-1/:antrag_id/position',
            TEIL_1_POSITION_CHECK: '/betrieb/:betrieb_nr/umstrukturierungsantrag/teil-1/:antrag_id/position/check',
            TEIL_1_POSITION_DETAILS: '/betrieb/:betrieb_nr/umstrukturierungsantrag/teil-1/:antrag_id/position/:position_id',
            TEIL_1_TAN_GENERATE: '/betrieb/:betrieb_nr/umstrukturierungsantrag/teil-1/:antrag_id/tan/generate',
            TEIL_1_TAN_SEND: '/betrieb/:betrieb_nr/umstrukturierungsantrag/teil-1/:antrag_id/tan/send',
            TEIL_1_TAN_VALIDATE: '/betrieb/:betrieb_nr/umstrukturierungsantrag/teil-1/:antrag_id/tan/validate/:tan',
            TEIL_1_DOWNLOAD_FINISHED: '/betrieb/:betrieb_nr/umstrukturierungsantrag/teil-1/:antrag_id/download/finished-pdf',
            TEIL_1_DOWNLOAD_PDF: '/betrieb/:betrieb_nr/umstrukturierungsantrag/teil-1/:antrag_id/download/pdf',
            TEIL_2_UEBERSICHT: '/betrieb/:betrieb_nr/umstrukturierungsantrag/teil-2/uebersicht',
            TEIL_2: '/betrieb/:betrieb_nr/umstrukturierungsantrag/:antragName',
            TEIL_2_CHECK: '/betrieb/:betrieb_nr/umstrukturierungsantrag/:antragName/check',
            PRUEFEN: '/betrieb/:betrieb_nr/umstrukturierungsantrag/:antragName/:antrag_id/pruefen',
            TEIL_2_DETAILS: '/betrieb/:betrieb_nr/umstrukturierungsantrag/:antragName/:antrag_id',
            TEIL_2_POSITION: '/betrieb/:betrieb_nr/umstrukturierungsantrag/:antragName/:antrag_id/position',
            TEIL_2_POSITION_CHECK: '/betrieb/:betrieb_nr/umstrukturierungsantrag/:antragName/:antrag_id/position/check',
            TEIL_2_POSITION_DETAILS: '/betrieb/:betrieb_nr/umstrukturierungsantrag/:antragName/:antrag_id/position/:position_id',
            TEIL_2_POSITION_QUELLFLAECHE: '/betrieb/:betrieb_nr/umstrukturierungsantrag/:antragName/:antrag_id/position/:position_id/quellflaeche',
            TEIL_2_POSITION_QUELLFLAECHE_CHECK: '/betrieb/:betrieb_nr/umstrukturierungsantrag/:antragName/:antrag_id/position/:position_id/quellflaeche/check',
            TEIL_2_POSITION_QUELLFLAECHE_DETAILS: '/betrieb/:betrieb_nr/umstrukturierungsantrag/:antragName/:antrag_id/position/:position_id/quellflaeche/:quellflaeche_id',
            TEIL_2_DOWNLOAD_FINISHED: '/betrieb/:betrieb_nr/umstrukturierungsantrag/:antragName/:antrag_id/download/finished-pdf',
            TEIL_2_DOWNLOAD_PDF: '/betrieb/:betrieb_nr/umstrukturierungsantrag/:antragName/:antrag_id/download/pdf',
            ALK: '/umstrukturierungsantrag/alk/:flurstueck?',
            REBSORTE: '/umstrukturierungsantrag/rebsorte',
            UNTERLAGE: '/umstrukturierungsantrag/unterlage',
            GEMARKUNG: '/umstrukturierungsantrag/gemarkung',
            TAN_GENERATE: '/betrieb/:betrieb_nr/umstrukturierungsantrag/:antragName/:antrag_id/tan/generate',
            TAN_SEND: '/betrieb/:betrieb_nr/umstrukturierungsantrag/:antragName/:antrag_id/tan/send',
            TAN_VALIDATE: '/betrieb/:betrieb_nr/umstrukturierungsantrag/:antragName/:antrag_id/tan/validate/:tan',
            GIS_ERROR_LOG: '/umstrukturierungsantrag/gis-error-log',
            FLURBEREINIGUNG: '/umstrukturierungsantrag/flurbereinigung',
        },
    },
    CMSFILE: {
        RICHTLINIEN: '/Umstrukturierung/Umstrukturierung_Richtlinien_Teil2.pdf',
        MERKBLATT_TEIL_1: '/Umstrukturierung/Merkblatt_Teil_1.pdf',
        AUSFUELLHILFE_TEIL_1: '/Umstrukturierung/Ausfuellhilfe_Teil_1.pdf',
        PIWI_REBSORTENLISTE: '/Umstrukturierung/PIWI-Rebsorten.pdf',
    },
};
